declare var Rollbar: any;

export default class RollbarUtils {
    static sendErrorToRollbar(errorObject: any, payload: any, onSuccess?: (err: any, data: any) => void) {
        if (typeof Rollbar !== "undefined") Rollbar.error(errorObject, payload, function(err: any, data: any) {
            if (err) {
                console.log("Error while reporting error to Rollbar: ", err);
                if (typeof onSuccess !== "undefined") onSuccess(err, null);
            } else {
                if (typeof onSuccess !== "undefined") onSuccess(null, data);
            }
        });
    }
}